import { XMarkIcon } from "@heroicons/react/24/outline";
import { Bars3Icon, PlusIcon } from "@heroicons/react/24/solid";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { Button } from "common/src/styles";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as BrandLogoText } from "../../assets/brand-logo-text.svg";
import { ReactComponent as BrandLogo } from "../../assets/brand-logo.svg";
import { ReactComponent as GrantsExplorerLogo } from "../../assets/topbar-logos-black.svg";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Navbar(props) {
  var _props$showWalletInte;
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const showWalletInteraction = (_props$showWalletInte = props.showWalletInteraction) !== null && _props$showWalletInte !== void 0 ? _props$showWalletInte : false;
  const GRANT_BUILDER = process.env.REACT_APP_GRANT_BUILDER;
  const HamburgerIcon = isNavbarOpen ? XMarkIcon : Bars3Icon;
  return /*#__PURE__*/_jsx("nav", {
    className: `bg-white fixed w-full z-10 py-4 border-b border-b-gray-200 ${props.customBackground}`,
    children: /*#__PURE__*/_jsx("div", {
      className: "mx-auto px-4 sm:px-6 lg:px-20",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col lg:flex-row justify-between",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex justify-between w-full lg:w-auto lg:justify-start",
          children: [/*#__PURE__*/_jsxs(Link, {
            to: "/",
            className: "flex-shrink-0 flex items-center",
            "data-testid": "home-link",
            children: [/*#__PURE__*/_jsx(BrandLogoText, {
              className: "hidden sm:block max-w-[200px] max-h-[40px]"
            }), /*#__PURE__*/_jsx(BrandLogo, {
              className: "sm:hidden w-auto max-w-[200px] max-h-[40px]"
            }), /*#__PURE__*/_jsxs("div", {
              className: "hidden sm:flex items-center",
              children: [/*#__PURE__*/_jsx("span", {
                className: "mx-4 lg:mx-6 text-grey-400",
                children: "|"
              }), /*#__PURE__*/_jsx(GrantsExplorerLogo, {
                className: "lg:inline-block md:inline-block"
              })]
            })]
          }), /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: () => setIsNavbarOpen(p => !p),
            className: "lg:hidden",
            children: /*#__PURE__*/_jsx("div", {
              className: "border-solid border rounded border-black p-2",
              children: /*#__PURE__*/_jsx(HamburgerIcon, {
                className: "text-black w-6 h-6"
              })
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: `${isNavbarOpen ? "d-flex" : "hidden"} mt-6 lg:flex`,
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex flex-row flex-wrap items-center lg:flex-nowrap gap-6",
            children: [GRANT_BUILDER && /*#__PURE__*/_jsx("a", {
              href: GRANT_BUILDER,
              target: "_blank",
              rel: "noreferrer",
              children: /*#__PURE__*/_jsxs(Button, {
                className: "rounded-md flex items-center",
                children: [/*#__PURE__*/_jsx(PlusIcon, {
                  className: "text-current h-6 w-6 mr-1"
                }), "New Project"]
              })
            }), showWalletInteraction && /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx("div", {
                "data-testid": "connect-wallet-button",
                id: "connect-wallet-button",
                children: /*#__PURE__*/_jsx(ConnectButton, {
                  showBalance: false,
                  chainStatus: {
                    largeScreen: "icon",
                    smallScreen: "icon"
                  }
                })
              })
            })]
          })
        })]
      })
    })
  });
}